import * as Browser from '../../browser';

export default (changesNotSaved) => ({
    init() {
        window.onbeforeunload = function (event) {
            if (changesNotSaved && !Browser.isFirefox()) {
                return true;
            }
        };
    },
});
